const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
  window.location.hostname === '[::1]' ||
  window.location.hostname.match(
    /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
  )
);

export function register(config) {
  if (import.meta.env.REACT_APP_API_PROTOCOL === 'https' && 'serviceWorker' in navigator) {

    const swUrl = new URL(window.location.origin + '/assets/service-workers/index.js');

    if (isLocalhost) {
      checkValidServiceWorker(swUrl, config);
      return navigator.serviceWorker.ready.then(() => {
        // eslint-disable-next-line no-console
        console.log(
          'This web app is being served cache-first by a service ' +
          'worker. To learn more, visit https://cra.link/PWA'
        );
      });
    } else {
      return registerValidSW(swUrl, config);
    }
  }
}

function registerValidSW(swUrl, config) {
  return navigator.serviceWorker
    .register(swUrl, { scope: '/' })
    .then(registration => {

      // eslint-disable-next-line no-console
      console.log('Service Worker registered with scope:', registration.scope);

      // Ensure the Service Worker is controlling the page
      if (navigator.serviceWorker.controller) {
        // eslint-disable-next-line no-console
        console.log('Service Worker is already controlling the page.');
      } else {
        // eslint-disable-next-line no-console
        console.log('Waiting for Service Worker to take control...');
        navigator.serviceWorker.addEventListener('controllerchange', function() {
          // eslint-disable-next-line no-console
          console.log('Service Worker has taken control.');

        });
      }

      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (installingWorker == null) {
          return;
        }
        installingWorker.onstatechange = () => {
          if (installingWorker.state === 'installed') {
            if (navigator.serviceWorker.controller) {
              if (config && config.onUpdate) {
                config.onUpdate(registration);
              }
            } else {
              if (config && config.onSuccess) {
                config.onSuccess(registration);
              }
            }
          }
        };
      };
    })
    .catch(error => {
      // eslint-disable-next-line no-console
      console.error('Error during service worker registration:', error);
    });
}

function checkValidServiceWorker(swUrl, config) {

  const options = {
    headers: { 'Service-Worker': 'script' },
  };

  return fetch(swUrl, options)
    .then(response => {
      const contentType = response.headers.get('content-type');
      if (
        response.status === 404 ||
        (contentType != null && contentType.indexOf('javascript') === -1)
      ) {
        navigator.serviceWorker.ready.then(registration => {
          registration.unregister().then(() => {
            window.location.reload();
          });
        });
      } else {
        registerValidSW(swUrl, config);
      }
    })
    .catch(() => {
      // eslint-disable-next-line no-console
      console.log(
        'No internet connection found. App is running in offline mode.'
      );
    });
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then(registration => {
        registration.unregister();
      })
      .catch(error => {
        // eslint-disable-next-line no-console
        console.error(error.message);
      });
  }
}